export type IYandexMetrikaEvents =
    | {
          type: YandexMetrikaMethods.reachGoal;
          payload: Parameters<IYandexMetrikaReachGoalHandler>;
      }
    | {
          type: YandexMetrikaMethods.params;
          payload: Parameters<IYandexMetrikaParamsHandler>;
      };

export type IYandexMetrikaReachGoalHandler = (
    target: string,
    params?: object,
    callback?: Function,
    ctx?: object
) => void;

type IYandexMetrikaParamsDataElement = string | number;

type IYandexMetrikaParamsData = {
    [key in IYandexMetrikaParamsDataElement]:
        | IYandexMetrikaParamsData
        | IYandexMetrikaParamsDataElement
        | IYandexMetrikaParamsDataElement[];
};

export type IYandexMetrikaParamsHandler = (
    params: IYandexMetrikaParamsData | IYandexMetrikaParamsData[]
) => void;

export type IYandexMetrikaInitParams = {
    id: number;
    clickmap?: boolean;
    trackLinks?: boolean;
    accurateTrackBounce?: boolean;
    webvisor?: boolean;
    experiments?: string;
    params?: IYandexMetrikaParams;
    yaGdprLang?: string;
};

export enum YandexMetrikaMethods {
    reachGoal = 'reachGoal',
    params = 'params',
}

export type IYandexMetrikaCounterParams = {
    id: number;
    clickmap?: boolean;
    trackLinks?: boolean;
    accurateTrackBounce?: boolean;
    webvisor?: boolean;
    experiments?: string;
    params?: IYandexMetrikaParams;
    yaGDPRLang?: string;
    url?: string;
};

type IYandexMetrikaParams = {
    appName: string;
    appVersion: string;
    isAuthorized: boolean;
};

export interface IYandexMetrikaApi {
    emit(event: IYandexMetrikaEvents): void;
}

export interface IYandexMetrika {
    reachGoal: IYandexMetrikaReachGoalHandler;
    params: IYandexMetrikaParamsHandler;
}

export type GlobalCounter = `yaCounter${number}`;

export interface IYandexMetrikaConstructor {
    new (params: IYandexMetrikaCounterParams): IYandexMetrika;
}

export interface IYandexMetrikaService {
    reachGoal: IYandexMetrikaReachGoalHandler;
    params: IYandexMetrikaParamsHandler;
}

export interface IYandexMetrikaServiceParams {
    metrikaApi: IYandexMetrikaApi;
}
